/* eslint-disable */

import React, { useEffect, useState } from "react";
import { GridActionsCellItem, useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import {
    requiredCell,
} from "../../js/utils/inputValidations";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ReplayIcon from '@mui/icons-material/Replay';
import { dateTimeToString, isArrayLength } from "../../js/utils/genericMethods";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { BasicTooltip } from "../Widgets/StyledComponents";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { updateEntityTree } from "../../js/redux/actions/userPref";
import { ButtonToolbar } from "../Widgets/Custom Inputs/Buttons";
import { useDebounceEffect } from "../../js/utils/customHooks";
import { Dialog, DialogContent } from "@mui/material";
import { Box, CircularProgress } from "@mui/material";
import { useEntityReadOnly } from "../../js/utils/useEntityReadOnly";


const RecycleBinGrid = ({ label, baseURL, ...props }) => {
    const apiRef = useGridApiRef();
    const { OTEntityID } = useParams();
    const readOnly = useEntityReadOnly(OTEntityID);
    const dispatch = useDispatch();

    const token = useSelector(state => state.auth.Token);
    const refreshRecycleBinGrid = useSelector(state => state.userPref.LastRecycleBinGridRefresh);
    const [forceGridRefresh, setForceGridRefresh] = useState(false);
    const [inSelection, setInSelection] = useState(false);
    const [selection, setSelection] = useState([]);
    const [restoringFiles, setRestoringFiles] = useState(false);
    const [onHoverDisableDropzone, setOnHoverDisableDropzone] = useState(false);

    function mouseEntering() {
        setOnHoverDisableDropzone(true);
    }
    function mouseLeaving() {
        setOnHoverDisableDropzone(false);
    }
    const deferEnter = useDebounceEffect(mouseEntering, 100);
    const deferLeave = useDebounceEffect(mouseLeaving, 100);

    useEffect(() => {
        setForceGridRefresh(prev => !prev);
    }, [refreshRecycleBinGrid]);

    useEffect(() => {
        handleCancelMoveClick();
    }, [setInSelection]);

    const handleSelectClick = () => {
        setInSelection(true);
    };

    const handleCancelMoveClick = () => {
        setInSelection(false);
        setSelection([]);
    };

    const handleRestoreClick = async () => {
        const url = "document/restoreSelectedDocuments";
        const documentsIDs = [...apiRef.current.getSelectedRows().keys()];
        if (documentsIDs.length === 0) {
            console.error("No files selected");
            return;
        }
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }

        setRestoringFiles(true);
        await Axios.post(url, documentsIDs, config);
        setRestoringFiles(false);
        setForceGridRefresh(prev => !prev);
        dispatch(updateEntityTree());
        setInSelection(false);
        setSelection([]);
    };
    
    const gridSpecificColumns = [
        {
            field: "Filename",
            headerName: t("field.Filename"),
            editable: true,
            minWidth: 150,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "Value", "Value");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "DeletedOn",
            headerName: t("field.DeletedOn"),
            width: 130,
            editable: false,
            valueFormatter: params =>
                dateTimeToString(params.value, "DateTime"),
        },
        {
            field: "DeletedBy",
            headerName: t("field.DeletedBy"),
            width: 130,
            editable: false
        },
        {
            field: "CreatedBy",
            headerName: t("field.CreatedBy"),
            width: 130,
            editable: false
        },
        {
            field: "OriginalLocation",
            headerName: t("field.OriginalLocation"),
            width: 420,
            editable: false
        },
    ];

    const detailSpecificActionsColumns = (
        params,
        _editing
    ) => [
        <>
            <GridActionsCellItem
                label={t("common.Restore")}
                disabled={readOnly}
                icon={
                    <BasicTooltip title={t("common.Restore")}>
                        <ReplayIcon />
                    </BasicTooltip>
                }
                onClick={async () => {
                    const config = {
                        headers: { Authorization: "Bearer " + token }
                    };
                    setRestoringFiles(true);
                    await Axios.post('document/restoreSelectedDocuments', [params.row.ID], config);
                    setRestoringFiles(false);
                    setForceGridRefresh(prev => !prev);
                    dispatch(updateEntityTree());
                }}
            />
        </>
    ];

    return (
        <>
            <Dialog open={restoringFiles} PaperProps={{
                    style: { backgroundColor: 'transparent', boxShadow: 'none' }
                }}
            >
                <DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <CircularProgress
                            size={90}
                            sx={{ top: 0, mb: 2 }}
                            color={"secondary"}
                        />
                    </Box>
                </DialogContent>
            </Dialog>
            <DataGridComponent
                apiRef={apiRef}
                baseURL={"document/getDeletedDocuments"}
                label={label}
                gridSpecificColumns={gridSpecificColumns}
                specificActionsColumns={detailSpecificActionsColumns}
                forceGridRefresh={forceGridRefresh}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "Filename", sort: "asc" }],
                    },
                }}
                paramURL={
                    "Filter[OTEntityID]=" + OTEntityID
                }
                getDetailPanelHeight={() => "auto"}
                isAddDisabled={true}
                isEditDisabled={true}
                isDeleteDisabled={true}
                checkboxSelection={inSelection}
                selectionModel={selection}
                onSelectionModelChange={newSelectionModel => {
                    setSelection(newSelectionModel);
                }}
                columnVisibilityModel={{
                    actions: !inSelection
                }}
                toolbar={{
                    newAction: !inSelection ? 
                        <ButtonToolbar
                            type="button"
                            onMouseEnter={deferEnter}
                            onMouseOut={deferLeave}
                            titleTooltip={t("common.Select")}
                            title={t("common.Select")}
                            startIcon={<CheckBoxOutlineBlankIcon />}
                            onClick={handleSelectClick}
                            disabled={readOnly}
                        />
                        :
                        <>
                            <ButtonToolbar
                                titleTooltip={t("view.document.CancelMove")}
                                title={t("common.Cancel")}
                                startIcon={<CancelOutlinedIcon />}
                                onClick={handleCancelMoveClick}
                            />
                            <ButtonToolbar
                                titleTooltip={t("common.Restore")}
                                title={t("common.Restore")}
                                startIcon={<ReplayIcon />}
                                onClick={handleRestoreClick}
                                disabled={readOnly || !isArrayLength(selection)}
                            />
                        </>
                }}
                {...props}
            />
        </>
    );
};

export default RecycleBinGrid;
